export const compactNumber = (value = 0) =>
  new Intl.NumberFormat("en", {
    notation: value > 9999 ? "compact" : "standard",
    maximumFractionDigits: 1,
  }).format(value);
export const formatDate = (value, short = false) =>
  value
    ? new Intl.DateTimeFormat(
        "en",
        short
          ? { month: "short", day: "numeric" }
          : { month: "short", day: "numeric", year: "numeric" },
      ).format(new Date(value))
    : "—";
export const initials = (name = "Admin") =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
export const fileSize = (bytes = 0) =>
  bytes > 1048576
    ? `${(bytes / 1048576).toFixed(1)} MB`
    : `${Math.max(1, Math.round(bytes / 1024))} KB`;
